import { Step } from "./steps/v2/step";

export type TourTrackManagerEvents = {
  wanderedOff: Step;
  targetNotFound: { step: Step; reasons: string[] };
  trackSatisfied: Step;
};

export const TourTrackManagerNamespace = "tourTrackManager" as const;
